<template>
  <div class="header-sidebar">
    <a :href="urlLanguagePrefix + '/catalog/'"
       class="header-sidebar__trigger"
       @mouseenter="isMenuOpen = true"
       @mouseleave="isMenuOpen = false">
      <span class="header-sidebar__trigger__icon">
        <svg width="20"
             height="20"
             viewBox="0 0 20 20"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.13793 6.55172C5.47103 6.55172 6.55172 5.47103 6.55172 4.13793C6.55172 2.80483 5.47103 1.72414 4.13793 1.72414C2.80483 1.72414 1.72414 2.80483 1.72414 4.13793C1.72414 5.47103 2.80483 6.55172 4.13793 6.55172ZM4.13793 8.27586C6.42325 8.27586 8.27586 6.42325 8.27586 4.13793C8.27586 1.85261 6.42325 0 4.13793 0C1.85261 0 0 1.85261 0 4.13793C0 6.42325 1.85261 8.27586 4.13793 8.27586Z"
                fill="#FF2F00"/>
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.8621 6.55172C17.1952 6.55172 18.2758 5.47103 18.2758 4.13793C18.2758 2.80483 17.1952 1.72414 15.8621 1.72414C14.529 1.72414 13.4483 2.80483 13.4483 4.13793C13.4483 5.47103 14.529 6.55172 15.8621 6.55172ZM15.8621 8.27586C18.1474 8.27586 20 6.42325 20 4.13793C20 1.85261 18.1474 0 15.8621 0C13.5767 0 11.7241 1.85261 11.7241 4.13793C11.7241 6.42325 13.5767 8.27586 15.8621 8.27586Z"
                fill="#FF2F00"/>
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.8621 18.2758C17.1952 18.2758 18.2758 17.1952 18.2758 15.8621C18.2758 14.529 17.1952 13.4483 15.8621 13.4483C14.529 13.4483 13.4483 14.529 13.4483 15.8621C13.4483 17.1952 14.529 18.2758 15.8621 18.2758ZM15.8621 20C18.1474 20 20 18.1474 20 15.8621C20 13.5767 18.1474 11.7241 15.8621 11.7241C13.5767 11.7241 11.7241 13.5767 11.7241 15.8621C11.7241 18.1474 13.5767 20 15.8621 20Z"
                fill="#FF2F00"/>
          <path fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.13793 18.2758C5.47103 18.2758 6.55172 17.1952 6.55172 15.8621C6.55172 14.529 5.47103 13.4483 4.13793 13.4483C2.80483 13.4483 1.72414 14.529 1.72414 15.8621C1.72414 17.1952 2.80483 18.2758 4.13793 18.2758ZM4.13793 20C6.42325 20 8.27586 18.1474 8.27586 15.8621C8.27586 13.5767 6.42325 11.7241 4.13793 11.7241C1.85261 11.7241 0 13.5767 0 15.8621C0 18.1474 1.85261 20 4.13793 20Z"
                fill="#FF2F00"/>
        </svg>
      </span>
      <span class="header-sidebar__trigger__text">
        {{ $t('up.menu.catalog') }}
      </span>
    </a>
    <transition>
      <div class="header-sidebar__content" v-show="isMenuOpen || alwaysOpen">
        <div class="page-container">
          <div class="header-sidebar__content__wrap" @mouseleave="setHoverIndex(null, $event)">
            <div class="header-sidebar__categories-wrap"
                 :style="{'height': sidebarHeight + 'px'}"
                 @mouseenter="isMenuOpen = true"
                 @mouseleave="isMenuOpen = false">
              <ul class="header-sidebar__list custom-scrollbar">
                <li
                  v-for="(item, idx) in sidebarMenu"
                  :key="idx"
                  class="header-sidebar__list__item"
                  @mouseenter="setHoverIndex(idx, $event)"
                  @mousemove="xDeltaCalculation(idx, $event)"
                  @mouseleave="setLeaveXPosition(idx, $event)"
                >
                  <a :href="item.full_url" class="header-sidebar__category" :class="{'open': hoverIndex === idx}">
                    <span class="header-sidebar__category__icon">
                      <svg v-if="isSpriteIcon(item.icon || item.image)">
                        <use :xlink:href="getSvgId(item.icon || item.image)"></use>
                      </svg>
                      <img
                        v-else-if="item.icon || item.image"
                        :src="item.icon || item.image"
                        :alt="item.name"
                      >
                    </span>
                    <span class="header-sidebar__category__label" >{{ item.name }}</span>
                  </a>
                  <div class="header-sidebar__submenu custom-scrollbar" :class="{'open': hoverIndex === idx}" v-if="item.items.length > 0">
                    <ul class="header-sidebar__submenu__list">
                      <li
                        v-for="(item, idx) in item.items"
                        :key="idx"
                        class="header-sidebar__submenu__item"
                      >
                        <a :href="item.full_url" class="header-sidebar__submenu__link">
                          <div class="header-sidebar__submenu__img-wrapper">
                            <img
                              :data-src="item.image"
                              :alt="item.name"
                              class="header-sidebar__submenu__thumb"
                            >
                          </div>
                          <div class="header-sidebar__submenu__label">{{ item.name }}</div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
              <a :href="urlLanguagePrefix + '/sprzet-i-narzedzia-ogrodnicze/'"
                 @mouseenter="setHoverIndex(null, $event)"
                 class="header-sidebar__category header-sidebar__category--to-category">
                <span class="header-sidebar__category__icon">
                  <img
                    src="/img/svgo/header/garden.svg"
                    :alt="$t('up.menu.garden')"
                  >
                </span>
                <span class="header-sidebar__category__label" >{{ $t('up.menu.garden') }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

const lazyLoad = {
  images: [],
  init (images) {
    this.images = images
  },
  loadAll () {
    if (this.images?.length < 1) return

    this.images.forEach((image) => {
      image.src = image.dataset.src
      image.removeAttribute('data-src')
    })

    this.images = []
  }
}

export default {
  name: 'HeaderSidebar',
  data () {
    return {
      isMenuOpen: false,
      hoverIndex: null,
      clientX: 0,
      enableChangeSubmenu: true,
      selectIndexTimeout: null
    }
  },
  props: {
    sidebarMenu: {
      type: Array,
      default: () => []
    },
    needToHideSidebar: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setHoverIndex (idx, event) {
      if (typeof idx === 'number') {
        if (this.enableChangeSubmenu) {
          this.hoverIndex = idx
          this.clientX = event.clientX
        }
      } else {
        this.clientX = 0
        this.hoverIndex = idx
        this.enableChangeSubmenu = true
      }
      if (typeof idx === 'number' && event.clientX > this.clientX) {
        this.selectIndexTimeout = setTimeout(() => {
          this.enableChangeSubmenu = true
          this.hoverIndex = idx
          this.clientX = event.clientX
        }, 200)
      }
    },
    xDeltaCalculation (idx, event) {
      if (event.clientX > this.clientX) {
        this.enableChangeSubmenu = false
      } else {
        this.enableChangeSubmenu = true
        this.setHoverIndex(idx, event)
      }
    },
    setLeaveXPosition (idx, event) {
      this.clientX = event.clientX - 1
      clearTimeout(this.selectIndexTimeout)
    },
    getSvgId (iconPath) {
      if (!iconPath) return
      const pathToSvgSprite = window.config?.category_icons_sprite_url || '/img/icons/category-icons-sprite.svg'
      const devider = '#'
      const preffix = 'static--cache'
      const id = iconPath.split('cache')[1].replace('.svg', '').replaceAll('/', '--')
      const svgId = `${pathToSvgSprite}${devider}${preffix}${id}`

      return svgId
    },
    isSpriteIcon (iconPath) {
      return typeof iconPath === 'string' && iconPath.includes('/cache/sidebar_menu/')
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix']),
    ...mapState({
      sidebarHeight: state => state.init.sidebarMainHeight
    }),
    alwaysOpen () {
      if (window.location.pathname === '/' || window.location.pathname === '/uk/') {
        return !this.needToHideSidebar
      } else {
        return false
      }
      // return this.needToHideSidebar || window.location.pathname === '/' || window.location.pathname === '/ru/'
    }
  },
  watch: {
    isMenuOpen: function (val) {
      const header = document.getElementById('header')
      if (val && !this.alwaysOpen) {
        header.classList.add('page-header--overlay')
      } else {
        header.classList.remove('page-header--overlay')
      }

      lazyLoad.loadAll()
    }
  },
  mounted () {
    const images = this.$el.querySelectorAll('.header-sidebar__submenu__thumb[data-src]')
    lazyLoad.init(images)
  }
}
</script>
